import React, { useEffect, useState, useRef } from "react";
import Icuser from "../../../assets/admin/images/icuser.png";
import ActiveJob from "../../../assets/admin/images/activejobs.png";
import PendingRequest from "../../../assets/admin/images/pendingrequest.png";
import TotalEarning from "../../../assets/admin/images/totalearning.png";
import SubsPlan from "../../../assets/admin/images/subscriptionplan.png";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/admin/routes.utlis";
import { api } from "../../../utlis/admin/api.utlis";
import ApiService from "../../../core/services/ApiService";
import Loader from "../../../layouts/loader/Loader";
import moment from "moment";
import { encode } from "base-64";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import FindJobModal from "./FindJobModal";
import FindCareImg from "../../../assets/admin/images/find-care.svg";
import FindJobImg from "../../../assets/admin/images/find-job.svg";
import PostJobImg from "../../../assets/admin/images/post-job.svg";

const Page = () => {
  const navigate = useNavigate();
  const [dashboard, setDashboard] = useState({
    totalUserCount: 0,
    totalCareProviderCount: 0,
    totalCareStaffCount: 0,
    totalCareJobRequests: [],
    totalActiveJobsCount: 0,
    totalPendingJobsCount: 0,
    careNetwork: [],
    AdvertisementList: [],
    careJobAssistList: []
  });
  const [graph, setGraph] = useState();
  const [earning, setEarning] = useState([]);
  const [subscription, setSubscription] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFindJobModal, setShowFindJobModal] = useState(false);
  const inputRef = useRef(null);
  const [location, setLocation] = useState({
    lat: null,
    lng: null,
    address: null,
    state: null,
  });

  const getDashboardData = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all dashboard => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDashboard(response.data.data);
    } else
      setDashboard({
        totalUserCount: 0,
        totalCareProviderCount: 0,
        totalCareStaffCount: 0,
        totalCareJobRequests: [],
        totalActiveJobsCount: 0,
        totalPendingJobsCount: 0,
        careNetwork: [],
        AdvertisementList: [],
        careJobAssistList: []
      });
    setLoading(false);
  };

  const getPaymentDetail = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all graph data => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setGraph(response.data.data);
      let earn = [];
      let subscribe = [];
      Object.values(response.data.data.monthlyEarning).map((element) => {
        earn.push(element.direct_payment_total);
        subscribe.push(element.subcription_payment_total);
      });
      setEarning(earn);
      setSubscription(subscribe);
    } else setGraph();
    setLoading(false);
  };



  useEffect(() => {
    window.scrollTo(0, 0);
    getDashboardData(api.dashboard);
    getPaymentDetail(api.dashboardGraph);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title">Dashboard</h3>
        </div>
        <div className="overview-section">
          <div className="row">
            <div className="col-md-4">
              <div className="card-overview">
                <div className="card-overview-image">
                  <img src={Icuser} alt="" height={80} />
                </div>
                <div className="card-overview-content">
                  <h4>Total Registered Users</h4>
                  <h2>
                    <Link to={routes.userManagement}>
                      {dashboard.totalUserCount ?? 0}
                    </Link>
                  </h2>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card-overview">
                <div className="card-overview-image">
                  <img src={Icuser} alt="" height={80} />
                </div>
                <div className="card-overview-content">
                  <h4>Total Registered Care Provider</h4>
                  <h2>
                    <Link to={routes.provider}>
                      {dashboard.totalCareProviderCount ?? 0}
                    </Link>
                  </h2>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card-overview">
                <div className="card-overview-image">
                  <img src={Icuser} alt="" height={80} />
                </div>
                <div className="card-overview-content">
                  <h4>Total Registered Care Staff</h4>
                  <h2>
                    <Link to={routes.jobOpportunities}>
                      {dashboard.totalCareStaffCount ?? 0}
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="overview-section">
          <div className="row">
            <div className="col-md-4">
              <div className="card-overview">
                <div className="card-overview-content">
                  <img src={FindCareImg} alt="" height={60} className="me-5" /> &nbsp; &nbsp; &nbsp;
                  <Link to="/user/find-care-home-assessment" className="btn btn-gr ms-5">
                    Find Care
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card-overview">
                <div className="card-overview-content">
                  <img src={FindJobImg} alt="" height={60} className="me-5" /> &nbsp; &nbsp; &nbsp; &nbsp;
                  <button className="btn btn-gr ms-5" onClick={() => setShowFindJobModal(true)}>
                    Find A Job
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card-overview">
                <div className="card-overview-content content-center">
                  <img src={PostJobImg} alt="" height={60} className="me-5" /> &nbsp; &nbsp; &nbsp;
                  <Link to="/user/care-network/job-post" className="btn btn-gr ms-5">
                    Post A Job
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="advertisement-section">
          <div className="care-title-header">
            <h2 className="heading-title">Care Assessment</h2>
            <div className="search-filter">
              <button
                type="button"
                className="btn-gr"
                onClick={() => navigate(routes.jobOpportunities)}
              >
                View All
              </button>
            </div>
          </div>
          <div className="requests-table-card">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email ID</th>
                    <th>Phone Number</th>
                    <th>Address</th>
                    <th>Start Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboard.careJobAssistList.length !== 0 ? (
                    dashboard.careJobAssistList.map((ele, indx) => {
                      return (
                        <tr key={indx}>
                          <td className="text-capitalize">
                            {" "}
                            {ele.first_name ?? "NA"}{" "}
                          </td>
                          <td className="text-lowercase">
                            {" "}
                            {ele.email_id ?? "NA"}{" "}
                          </td>
                          <td> {ele.phone ?? "NA"} </td>
                          <td> {ele.address ?? "NA"} </td>
                          <td> {ele.start_date ?? "NA"} </td>
                          <td>
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.careAssessmentDetail, {
                                  state: {
                                    id: encode(ele.id),
                                  },
                                });
                              }}
                            >
                              <label
                                style={{ cursor: "pointer" }}
                                className="badge badge-gradient-success"
                              >
                                <i className="fa fa-eye"></i>
                              </label>
                            </Link>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="5">
                        <div>
                          <p>No record found</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="requests-section">
          <div className="care-title-header">
            <h2 className="heading-title">Care Job Requests</h2>
            <div className="search-filter">
              <button
                type="button"
                className="btn-gr"
                onClick={() => navigate(routes.careJob)}
              >
                View All
              </button>
            </div>
          </div>
          <div className="requests-content">
            <div className="row">
              <div className="col-md-9 col-lg-9 mt-3">
                <div className="requests-table-card">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th> Name </th>
                          <th> Job ID </th>
                          <th> Status </th>
                          <th> Start Date </th>
                          <th> Time </th>
                          <th> Frequency </th>
                          <th> Action </th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboard.totalCareJobRequests.length !== 0 ? (
                          dashboard.totalCareJobRequests.map((ele, indx) => {
                            return (
                              <tr key={indx}>
                                <td className="text-capitalize">
                                  {ele.first_name ?? "NA"}{" "}
                                </td>
                                <td>{ele.job_id ?? "NA"} </td>
                                <td>{ele.request_status ?? "NA"}</td>
                                <td>
                                  {moment(ele.start_date, "YYYY-MM-DD").format("MM-DD-YYYY")}
                                </td>
                                <td>{ele.start_time}</td>
                                <td>
                                  {ele.frequency === "O"
                                    ? "One Time"
                                    : ele.frequency === "W"
                                      ? "Repeat Weekly"
                                      : "Repeat Monthly"}
                                </td>
                                <td>
                                  <Link
                                    title="View Detail"
                                    to=""
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigate(routes.careJobDetails, {
                                        state: {
                                          id: encode(ele.id),
                                        },
                                      });
                                    }}
                                  >
                                    <label
                                      style={{ cursor: "pointer" }}
                                      className="badge badge-gradient-success"
                                    >
                                      <i className="fa fa-eye"></i>
                                    </label>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr className="text-center">
                            <td colSpan="7">
                              <div>
                                <p>No record found</p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-lg-3  mt-3">
                <div className="activejbs-card">
                  <div className="activejbs-card-content">
                    <h6>Active Jobs</h6>
                    <h2>
                      <Link to={routes.careJob}>
                        {dashboard.totalActiveJobsCount ?? 0}
                      </Link>
                    </h2>
                  </div>
                  <div className="activejbs-card-image">
                    <img src={ActiveJob} alt="" height={60} />
                  </div>
                </div>

                <div className="activejbs-card">
                  <div className="activejbs-card-content">
                    <h6>Pending Requests</h6>
                    <h2>
                      <Link to={routes.careJob}>
                        {dashboard.totalPendingJobsCount ?? 0}
                      </Link>
                    </h2>
                  </div>
                  <div className="activejbs-card-image">
                    <img src={PendingRequest} alt="" height={60} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="advertisement-section">
          <div className="care-title-header">
            <h2 className="heading-title">Payments</h2>
            <div className="search-filter wd30"></div>
          </div>
          <div className="payments-content">
            <div className="row">
              <div className="col-md-5">
                <div className="payments-overview">
                  <div className="payments-overview-image">
                    <img src={TotalEarning} alt="" height={40} />
                  </div>
                  <div className="payments-overview-content">
                    <h4>Total Earning</h4>
                    <h2>${graph?.totalEarning?.payment_total ?? 0} </h2>
                    <h6 className="card-text">
                      {moment().format("MMM, yyyy")}
                    </h6>
                  </div>
                </div>

                <div className="payments-overview">
                  <div className="payments-overview-image">
                    <img src={SubsPlan} alt="" height={40} />
                  </div>
                  <div className="payments-overview-content">
                    <h4>Total Subscription Plan Purchased</h4>
                    <h2>
                      ${graph?.totalEarning?.subcription_payment_total ?? 0}{" "}
                    </h2>
                    <h6 className="card-text">
                      {moment().format("MMM, yyyy")}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <div className="barchartcard">
                  <Bar
                    data={{
                      labels: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                      ],
                      datasets: [
                        {
                          label: "Total Earning",
                          data: earning,
                          backgroundColor: "rgba(255, 191, 150, 1)",
                          borderColor: "rgba(255, 191, 150, 1)",
                          borderWidth: 1,
                          barPercentage: 0.5,
                          categoryPercentage: 0.5,
                          pointRadius: 0,
                          fill: "origin",
                        },
                        {
                          label: "Total Subscription Plan Purchased",
                          data: subscription,
                          backgroundColor: "rgba(54, 215, 232, 1)",
                          borderColor: "rgba(54, 215, 232, 1)",
                          borderWidth: 1,
                          barPercentage: 0.5,
                          categoryPercentage: 0.5,
                          pointRadius: 0,
                          fill: "origin",
                        },
                      ],
                    }}
                    options={{
                      responsive: true,
                      plugins: {
                        tooltip: {
                          callbacks: {
                            label: (context) => {
                              let value = context.raw;
                              return `$${value.toLocaleString()}`;
                            },
                          },
                        },
                      },
                      scales: {
                        y: {
                          ticks: {
                            callback: (value) => `$${value.toLocaleString()}`,
                          },
                        },
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="advertisement-section">
          <div className="care-title-header">
            <h2 className="heading-title">Posted Jobs</h2>
            <div className="search-filter">
              <button
                type="button"
                className="btn-gr"
                onClick={() => navigate(routes.jobOpportunities)}
              >
                View All
              </button>
            </div>
          </div>
          <div className="requests-table-card">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th> Name </th>
                    <th> Job ID </th>
                    <th> Salary </th>
                    <th> Work Experience </th>
                    <th> Status </th>
                    <th> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {dashboard.careNetwork.length !== 0 ? (
                    dashboard.careNetwork.map((ele, indx) => {
                      return (
                        <tr key={indx}>
                          <td>{ele.title ?? "NA"}</td>
                          <td> {ele.job_id ?? "NA"} </td>
                          <td>
                            {ele.currency ?? "$"}
                            {ele.pay_range ?? "0"}/{ele.pay_range_type ?? ""}
                          </td>
                          <td>{ele.working_expirence ?? "NA"} Years</td>
                          <td>{ele.request_status ?? "NA"}</td>
                          <td>
                            <Link
                              title="View Detail"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.jobOpportunityDetail, {
                                  state: {
                                    id: encode(ele.id),
                                  },
                                });
                              }}
                            >
                              <label
                                style={{ cursor: "pointer" }}
                                className="badge badge-gradient-success"
                              >
                                <i className="fa fa-eye"></i>
                              </label>
                            </Link>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="5">
                        <div>
                          <p>No record found</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="advertisement-section">
          <div className="care-title-header">
            <h2 className="heading-title">Advertisement</h2>
            <div className="search-filter">
              <button
                type="button"
                className="btn-gr"
                onClick={() => navigate(routes.advertisement)}
              >
                View All
              </button>
            </div>
          </div>

          <div className="row g-2">
            {dashboard.AdvertisementList.length !== 0
              ? dashboard.AdvertisementList.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-4">
                    <div className="advertisement-card">
                      <div className="advertisement-user-image">
                        {ele.image === null ||
                          ele.image === "" ||
                          ele.image === undefined ? (
                          <img
                            src={NoImage}
                            className="mb-2 mw-100 w-100 rounded"
                            alt=""
                            height={190}
                            width={250}
                            style={{
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                          />
                        ) : (
                          <img
                            src={ele.image}
                            height={190}
                            width={250}
                            className="mb-2 mw-100 w-100 rounded"
                            alt=""
                            style={{
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                          />
                        )}
                      </div>
                      <div className="advertisement-content">
                        <h4>{ele.title ?? "NA"}</h4>
                        <Link
                          to=""
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(routes.advertisementDetails, {
                              state: {
                                id: encode(ele.id),
                              },
                            });
                          }}
                          className="viewmorebtn mb-3"
                        >
                          View More
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })
              : "No advertisement found"}
          </div>
        </div>
      </div>

      <FindJobModal
        show={showFindJobModal}
        onHide={() => setShowFindJobModal(false)}
        inputRef={inputRef}
        location={location}
        setLocation={setLocation}
      />

    </>
  );
};

export default Page;
